import { DateTime } from 'luxon'

// Rótulos curtos de mês (Jan..Dez) para o cabeçalho da tabela e o eixo dos gráficos — as
// chaves que casam com a resposta da API vêm de DreService.getMonthKeys.
export const MONTH_HEADER_LABELS = Array.from({ length: 12 }, (_, index) => {
  const label = DateTime.local(2000, index + 1, 1).setLocale('pt-BR').toFormat('LLL').replace('.', '')
  return label.charAt(0).toUpperCase() + label.slice(1)
})

export const formatPercentage = value => `${(value * 100).toFixed(1).replace('.', ',')}%`

/*
  Dinheiro em texto puro, do mesmo jeito que o `MoneyText` desenha: "R$ 17.539,00". Serve onde
  não dá para montar um componente — atributo `title`, rótulo de gráfico, mensagem de diálogo.
*/
export const formatMoney = value => `R$ ${Number(value ?? 0).toLocaleString('pt-BR', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}`
